import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WidgetsService {
    private readonly _router = inject(Router);

    /** Inventory number of the vehicle currently open in outlet-right0, or null. */
    readonly openVehicleInventoryNumber = toSignal(
        this._router.events.pipe(
            filter(e => e instanceof NavigationEnd),
            startWith(null),
            map(() => {
                const outlet = this._router.routerState.snapshot.root.firstChild?.children
                    .find(c => c.outlet === 'outlet-right0');
                return outlet?.params['inventoryNumber'] ?? null;
            })
        ),
        { initialValue: null as string | null }
    );

    openVehicle(inventoryNumber: string): void {
        if (this.openVehicleInventoryNumber() === inventoryNumber) {
            this._router.navigate(['', { outlets: { 'outlet-right0': null, 'outlet-right1': null, 'outlet-right2': null, outlet1: null, outlet2: null } }]);
        } else {
            this._router.navigate(['', { outlets: { 'outlet-right0': ['vehicle', inventoryNumber], 'outlet-right1': null, 'outlet-right2': null, outlet1: null, outlet2: null } }]);
        }
    }
}
